import { render, staticRenderFns } from "./ObjTable.vue?vue&type=template&id=3a74bd26&scoped=true&"
import script from "./ObjTable.vue?vue&type=script&lang=js&"
export * from "./ObjTable.vue?vue&type=script&lang=js&"
import style0 from "./ObjTable.vue?vue&type=style&index=0&id=3a74bd26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74bd26",
  null
  
)

export default component.exports